import { ProgressStep } from '@monorepo/types';

export const calculateProgressPercentage = (
  steps: ProgressStep[],
  activeStepIndex: number,
  currentUserProgress: number,
): number => {
  if (activeStepIndex < 0) return 0;

  // Find the active step
  const activeStep = steps[activeStepIndex];
  const nextStepIndex = activeStepIndex + 1;

  // If this is the last step, no progress bar (target already reached)
  if (nextStepIndex >= steps.length) {
    return 0;
  }

  // Apply profit-target-5ers logic:
  const baseBalance = activeStep.buyingPower; // Starting balance
  const target = activeStep.target; // Target profit needed
  const currentPNL = currentUserProgress; // Current profit/loss

  // Calculate current equity (baseBalance + PNL)
  const currentEquity = baseBalance + currentPNL;
  const targetEquity = baseBalance + target;

  // Progress within current step: from baseBalance to baseBalance + target
  const progressRange = targetEquity - baseBalance; // Total range = target
  const currentProgress = currentEquity - baseBalance; // Current progress = PNL
  const progressInStep = Math.max(
    0,
    Math.min(1, currentProgress / progressRange),
  );

  // Convert to percentage for the segment between active and next node
  // This represents how much of the segment between two nodes is filled
  return progressInStep * 100;
};

export const findActiveStepIndex = (steps: ProgressStep[]): number => {
  return steps.findIndex((step) => step.active);
};
